document.addEventListener('DOMContentLoaded', (event) => {

    const tn_input = document.getElementById('tracking_number_data');
    const tn_button = document.getElementById('tracking_number_button');
  
    if (!!tn_input || !!tn_button) {
      tn_button.addEventListener('click', e => {
  
          const uri = '/tracking/';
          const value = tn_input.value.trim();
          if (!value.length) {
            return;
          }
          // const old = e.target.dataset.number;
          // if (old == value) {
          //   return;
          // }
          const url_origin = window.location.origin;
          const params = new URLSearchParams();
          params.set('tn', value);
          const get_params_string = params.toString();
          // goto link
          window.location.href = url_origin + uri + '?' + get_params_string;
        
      });
    }
  });

  